import React, { useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Quill styles
import axios from 'axios';

const modules = {
  toolbar: [
    [{ 'header': '1'}, { 'header': '2'}, { 'font': [] }],
    [{size: []}],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
    ['link', 'image', 'video'],
    [{ 'color': [] }, { 'background': [] }],  // Text color and background color options
    [{ 'align': [] }],
    ['clean']  // Remove formatting
  ]
};

const AdminPageEditor = () => {
  const [pages, setPages] = useState([]);
  const [selectedPage, setSelectedPage] = useState(null);
  const [editorContent, setEditorContent] = useState('');
  const quillRef = useRef(null);

  useEffect(() => {
    // Fetch pages from your API or server
    axios.get('/api/pages')  // Replace with your API endpoint
      .then(response => setPages(response.data))
      .catch(error => console.error('Error fetching pages:', error));
  }, []);

  const handlePageSelect = (event) => {
    const pageId = event.target.value;
    const page = pages.find(p => p.id === pageId);
    setSelectedPage(page);
    setEditorContent(page ? page.content : ''); // Load the content of the selected page
  };

  const handleContentChange = (content) => {
    setEditorContent(content);
  };

  const saveChanges = () => {
    if (selectedPage) {
      axios.post(`/api/pages/${selectedPage.id}`, { content: editorContent })
        .then(response => {
          alert('Content updated successfully!');
        })
        .catch(error => console.error('Error saving changes:', error));
    } else {
      alert('Please select a page to edit.');
    }
  };

  const insertStyledDiv = () => {
    const quill = quillRef.current.getEditor(); // Get Quill editor instance
    const range = quill.getSelection();
    const value = '<div style="background-color: yellow; padding: 10px;">This is a custom div with styles!</div>';
    quill.clipboard.dangerouslyPasteHTML(range.index, value);
  };

  return (
    <div className="admin-page-editor">
      <h1>Admin Page Editor</h1>
      <div className="page-selection">
        <label htmlFor="page-select">Select a page to edit:</label>
        <select id="page-select" onChange={handlePageSelect}>
          <option value="">--Select a Page--</option>
          {pages.map(page => (
            <option key={page.id} value={page.id}>{page.title}</option>
          ))}
        </select>
      </div>
      {selectedPage && (
        <div className="editor-container">
          <ReactQuill 
            ref={quillRef} 
            value={editorContent} 
            onChange={handleContentChange} 
            modules={modules}
          />
          <button onClick={insertStyledDiv}>Insert Styled Div</button>
          <button onClick={saveChanges}>Save Changes</button>
        </div>
      )}
    </div>
  );
};

export default AdminPageEditor;
